<div *ngIf="dropdownListType === this.itemsListTypes.SERVER_SIDE_SEARCH">
  <ng-select [items]="selectDropdownListApi$ | async"
  class="icici-custom"
  [ngClass]="customClass"
  bindLabel="company_name"
  [multiple]="true"
  [hideSelected]="true"
  [loading]="multiselectLoading"
  [typeahead]="selectInputControl$"
  [(ngModel)]="selectedItems"
  (change)="onSelectInputChange($event)"
  (add)="onItemAdded($event)"
  (remove)="onItemRemoved($event)"
  (clear)="onInputClear()"
  notFoundText={{notFoundText}}
  placeholder={{placeholder}}>
  </ng-select>
</div>

<div *ngIf="dropdownListType === this.itemsListTypes.STATIC_ITEMS_LIST">
  <ng-select [items]="dropDownItemsList"
  class="icici-custom"
  [multiple]="true"
  bindLabel="name"
  [hideSelected]="true"
  [loading]="multiselectLoading"
  [typeahead]="selectInputControl$"
  [(ngModel)]="selectedItems"
  (change)="onSelectInputChange($event)"
  (add)="onItemAdded($event)"
  (remove)="onItemRemoved($event)"
  (clear)="onInputClear()"
  notFoundText={{notFoundText}}
  placeholder={{placeholder}}>
  </ng-select>
</div>

